import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators'
import IntegrationApi from '@/api/integration'

@Module({ namespaced: true })
export default class IntegrationsModule extends VuexModule {
    public filters: IntegrationsModuleFiltersEntity = {
        name: '',
        partner: '',
        category: '',
        status: '',
        onlySpotlight: false,
    }
    public isLoading: boolean = false
    public integrationModules: IntegrationModuleEntity[] = []
    public modulecategories: ModulecategoryEntity[] = []
    public modulepartners: ModulepartnerEntity[] = []
    public totalSpotlights: number = 0

    @Mutation
    public setFilters(filters: IntegrationsModuleFiltersEntity) {
        this.filters = filters
    }

    @Mutation
    public setLoading(loading: boolean) {
        this.isLoading = loading
    }

    @Mutation
    public setIntegrationModules(integrationModules: IntegrationModuleEntity[]) {
        this.integrationModules = integrationModules
    }

    @Mutation
    public setModulepartners(modulepartners: ModulepartnerEntity[]) {
        this.modulepartners = modulepartners
    }

    @Mutation
    public setModulecategories(modulecategories: ModulecategoryEntity[]) {
        this.modulecategories = modulecategories
    }

    @Mutation
    public setTotalSpotlights(totalSpotlights: number) {
        this.totalSpotlights = totalSpotlights
    }

    @Mutation
    public removeIntegrationModule(id: number) {
        const index = this.integrationModules.findIndex((element) => id === element.id)
        this.integrationModules.splice(index, 1)
    }

    @Action
    public filterIntegrationModules(filters: IntegrationsModuleFiltersEntity) {
        this.context.commit('setFilters', filters)
        this.context.dispatch('fetchIntegrationModules')
    }

    @Action
    public async fetchIntegrationModules(): Promise<boolean> {
        if (this.isLoading) {
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', true)

        const params = {
            name: this.filters.name.trim(),
            partner: this.filters.partner.trim(),
            category: this.filters.category,
            status: this.filters.status,
            onlySpotlight: this.filters.onlySpotlight,
        }

        const response = await IntegrationApi.getIntegrations(params)

        if (response.status === 'cancelled') {
            return Promise.resolve(false)
        }

        if (response.status === 'success') {
            this.context.commit('setIntegrationModules', response.data!.modules)
            this.context.commit('setModulepartners', response.data!.partners)
            this.context.commit('setModulecategories', response.data!.categories)
            this.context.commit('setTotalSpotlights', response.data!.totalSpotlights)
        } else {
            alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', false)
        return Promise.resolve(true)
    }

    @Action
    public async updateIntegrationModule(params: any): Promise<boolean> {
        if (this.isLoading) {
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', true)

        const response = await IntegrationApi.updateIntegration(params)

        if (response.status === 'cancelled') {
            return Promise.resolve(false)
        }

        if (response.status !== 'success') {
            alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', false)
        return Promise.resolve(true)
    }

    @Action
    public async deleteIntegrationModule(id: number): Promise<boolean> {
        if (this.isLoading) {
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', true)

        const response = await IntegrationApi.deleteIntegration(id)

        if (response.status === 'cancelled') {
            return Promise.resolve(false)
        }

        if (response.status !== 'success') {
            alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(false)
        }

        this.context.commit('removeIntegrationModule', id)
        this.context.commit('setLoading', false)
        return Promise.resolve(true)
    }

    @Action
    public async orderIntegrationModules(params: any): Promise<boolean> {
        if (this.isLoading) {
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', true)

        const response = await IntegrationApi.orderIntegrations(params)

        if (response.status === 'cancelled') {
            return Promise.resolve(false)
        }

        if (response.status !== 'success') {
            alert(response.message)

            this.context.commit('setLoading', false)
            return Promise.resolve(false)
        }

        this.context.commit('setLoading', false)
        return Promise.resolve(true)
    }
}
